import BackButton from "@/components/BackButton";

export default function LegalLayout({ title, updated, children, testid }) {
  return (
    <main data-testid={testid} className="max-w-3xl mx-auto px-6 md:px-10 py-14 md:py-20">
      <BackButton to="/" label="Back to home" testid={`${testid}-back-link`} />

      <header className="mt-8">
        <p className="overline-label text-accent">Legal</p>
        <h1 className="mt-3 font-display text-4xl md:text-6xl tracking-tight leading-[1.05]">
          {title}
        </h1>
        {updated && (
          <p className="mt-3 font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground">
            Last updated · {updated}
          </p>
        )}
      </header>

      <article className="mt-10 space-y-8 lyric-line text-lg leading-relaxed text-foreground/90">
        {children}
      </article>
    </main>
  );
}
